var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWithoutPrice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_96_4310)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    width: 24,
    height: 24,
    rx: 4,
    fill: "black",
    fillOpacity: 0.04
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.4402 11.5799C21.4402 16.3492 17.5694 20.2199 12.8002 20.2199C8.03088 20.2199 4.16016 16.3492 4.16016 11.5799C4.16016 6.81066 8.03088 2.93994 12.8002 2.93994",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5412 8.83301H12.0342C11.2879 8.83301 10.6836 9.43735 10.6836 10.1827C10.6836 10.929 11.2879 11.5333 12.0342 11.5333H13.5773C14.3226 11.5333 14.927 12.1377 14.927 12.8831C14.927 13.6294 14.3226 14.2337 13.5773 14.2337H11.0694",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8066 14.2313V15.3653M12.8066 7.69116V8.83445",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1154 5.26433L20.7584 6.90826M19.1154 5.26433L17.4727 3.62061M19.1154 5.26433L17.4727 6.90826M19.1154 5.26433L20.7584 3.62061",
    stroke: "black",
    strokeOpacity: 0.85,
    strokeWidth: 1.44,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_96_4310"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.800781,
    width: 24,
    height: 24,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWithoutPrice);
export default __webpack_public_path__ + "static/media/withoutPrice.28fa5d8d53d877e16fca44d44767a6e3.svg";
export { ForwardRef as ReactComponent };